import { customFetcher, customFetcherRaw } from './customFetcher';
import { IKurtaxeRate, kurtaxeRateSchema } from '../Interfaces/IReservationPrice';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const KURTAXE_RATES_QUERY_KEY = ['kurtaxeRates'];

export const useGetKurtaxeRates = () => {
    const { data: kurtaxeRates, isLoading: isLoadingKurtaxeRates } = useQuery<IKurtaxeRate[]>({
        refetchOnWindowFocus: false,
        queryKey: KURTAXE_RATES_QUERY_KEY,
        queryFn: async () => {
            const data = await customFetcher<unknown[]>({ endpoint: '/kurtaxe/rates/' });
            return kurtaxeRateSchema.array().parse(data);
        },
        initialData: [],
    });
    return { kurtaxeRates: kurtaxeRates as IKurtaxeRate[], isLoadingKurtaxeRates };
};

export const useUpdateKurtaxeRates = () => {
    const queryClient = useQueryClient();
    const { mutateAsync: updateKurtaxeRates, isPending: isUpdatingKurtaxeRates } = useMutation<
        IKurtaxeRate[],
        Error,
        Array<{ category: IKurtaxeRate['category']; rate: number }>
    >({
        mutationFn: (rates) =>
            customFetcher<IKurtaxeRate[]>({
                endpoint: '/kurtaxe/rates/',
                method: 'PUT',
                body: rates,
            }),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: KURTAXE_RATES_QUERY_KEY });
        },
    });
    return { updateKurtaxeRates, isUpdatingKurtaxeRates };
};

/**
 * Lädt den Kurtaxe-Jahresexport (pdf|csv) herunter und stößt den Browser-Download an.
 */
export const downloadKurtaxeExport = async (year: number, fmt: 'pdf' | 'csv'): Promise<void> => {
    const response = await customFetcherRaw({
        endpoint: `/kurtaxe/export/?year=${year}&fmt=${fmt}`,
    });
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Kurtaxe_Escheck_${year}.${fmt}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
